import { useLLMStream } from "../hooks/useLLMStream";
import { useScriptedRun } from "../hooks/useScriptedRun";
import { ChatPane } from "./chat/ChatPane";
import { IconStrip } from "./chrome/IconStrip";
import { MetaFooter } from "./chrome/MetaFooter";
import { TopBar } from "./chrome/TopBar";
import { Panel } from "./panel/Panel";
import styles from "./SplitShell.module.css";

export function SplitShell() {
  useScriptedRun(true);
  const { send } = useLLMStream();

  return (
    <div className={styles.app}>
      <TopBar />
      <div className={styles.body}>
        <section className={styles.chatCol} aria-label="ripper conversation">
          <ChatPane onSend={send} />
        </section>
        <section className={styles.panelCol} aria-label="intelligence panel">
          <Panel />
        </section>
        <IconStrip />
      </div>
      <MetaFooter />
    </div>
  );
}
